export interface BufferedRoomEvent<T> {
  type: string;
  payload: T;
}

export class BufferedRoomEvents<T> {
  private ready = false;
  private readonly pending: BufferedRoomEvent<T>[] = [];

  constructor(
    private readonly dispatch: (event: BufferedRoomEvent<T>) => void,
    private readonly capacity = 128,
  ) {
    if (!Number.isInteger(capacity) || capacity < 1)
      throw new RangeError("Event buffer capacity must be a positive integer");
  }

  push(event: BufferedRoomEvent<T>): void {
    if (this.ready) {
      this.dispatch(event);
      return;
    }
    if (this.pending.length === this.capacity) this.pending.shift();
    this.pending.push(event);
  }

  flush(): void {
    this.ready = true;
    for (const event of this.pending.splice(0)) this.dispatch(event);
  }

  reset(): void {
    this.ready = false;
    this.pending.length = 0;
  }
}
